import type { FunctionComponent } from "react"

import { TeamsWrapper } from "@/features/companyDetail/components/Teams/TeamsWrapper/TeamsWrapper"

export const Teams: FunctionComponent = () => (
  <div data-testid="company_teams">
    <TeamsWrapper />
  </div>
)
